import '@firebase/analytics';
//# sourceMappingURL=index.esm.js.map
